(function () {
  "use strict";

  angular.module("virtualFairs").config(VirtualFairsRoute);

  VirtualFairsRoute.$inject = ["$stateProvider"];

  /* @ngInject */
  function VirtualFairsRoute($stateProvider) {
    $stateProvider
      .state("root.virtualfair", {
        abstract: true,
        url: "/virtualfair",
        resolve: {
          /* Inserir as regras de Acl aqui! */
        },
      })
      .state("root.virtualfair.seminars", {
        url: "/seminars",
        views: {
          "inner-view@root": {
            templateUrl:
              "templates/virtualfairs/seminars/virtualFairSeminars.html",
            controller: "VirtualFairSeminarsController",
            controllerAs: "virtualFairSeminars",
          },
        },
        params: {
          msg: null,
          error: false,
        },
      })
      .state("root.virtualfair.seminars.form", {
        url: "/form/:id?",
        resolve: {
          seminars: function(VirtualFairService, $stateParams) {
            if($stateParams.id) {
              return VirtualFairService.getSeminarById($stateParams.id).then(function(response) {
                return response.data;
              });
            }
            return null;
          }
        },
        views: {
          "inner-view@root": {
            templateUrl: "templates/virtualfairs/seminars/form/form.html",
            controller: "VirtualFairSeminarsFormController",
            controllerAs: "virtualFairSeminarsForm",
          },
        },
        params: {id: null},
      })
      .state("root.virtualfair.preApproved", {
        url: "/pre-approved",
        views: {
          "inner-view@root": {
            templateUrl:
              "templates/virtualfairs/pre-approved/virtualFairPreApproved.html",
            controller: "VirtualFairPreApprovedController",
            controllerAs: "virtualFairPreApproved",
          },
        },
        params: {
          msg: null,
          error: false,
        },
      })
      .state("root.virtualfair.deleteEventVisitors", {
        url: "/delete-event-visitor",
        views: {
          "inner-view@root": {
            templateUrl: "templates/virtualfairs/delete-event-visitors/list.html",
            controller: "VirtualDeleteEventVisitorsController",
            controllerAs: "virtualDeleteEventVisitors",
          },
        },
        resolve: {
          networkingEventUsersTypes,
          virtualFairs: function () {
            return null;
          }
        },
      })
      .state("root.virtualfair.networking_event", {
        url: "/networking-event",
        views: {
          "inner-view@root": {
            templateUrl: "templates/virtualfairs/networking-event/list.html",
            controller: "VirtualFairNetworkingEventController",
            controllerAs: "virtualNetworkingEvent",
          },
        },
        resolve: {
          networkingEventUsersTypes,
          virtualFairs: function () {
            return null;
          }
        },
      })
      .state("root.virtualfair.approved", {
        url: "/approved",
        views: {
          "inner-view@root": {
            templateUrl:
              "templates/virtualfairs/approved/virtualFairApproved.html",
            controller: "VirtualFairApprovedController",
            controllerAs: "virtualFairApproved",
          },
        },
        params: {
          msgToast: null,
        },
      })
      .state("root.virtualfair.boothSetup", {
        url: "/booth-setup",
        views: {
          "inner-view@root": {
            templateUrl:
              "templates/virtualfairs/booth-setup/virtualBoothSetup.html",
            controller: "VirtualFairBoothSetupController",
            controllerAs: "virtualFairBoothSetup",
          },
        },
      })
      .state("root.virtualfair.importFairData", {
        url: "/import-fair-data",
        views: {
          "inner-view@root": {
            templateUrl:
              "templates/virtualfairs/import-fair-data/virtualFairImportData.html",
            controller: "VirtualFairImportDataController",
            controllerAs: "virtualFairImportData",
          },
        },
      })
      .state("root.virtualfair.importVisitors", {
        url: "/general-visitors",
        views: {
          "inner-view@root": {
            templateUrl:
              "templates/virtualfairs/general-visitors/virtualFairImportVisitors.html",
            controller: "VirtualFairImportVisitorsController",
            controllerAs: "virtualFairImportVisitors",
          },
        },
      })
      .state("root.virtualfair.exportFairData", {
        url: "/export-fair-data",
        views: {
          "inner-view@root": {
            templateUrl:
              "templates/virtualfairs/export-fair-data/virtualFairExportData.html",
            controller: "VirtualFairExportDataController",
            controllerAs: "virtualFairExportData",
          },
        },
      })
      .state("root.virtualfair.totalStudent", {
        url: "/total-student",
        views: {
          "inner-view@root": {
            templateUrl:
              "templates/virtualfairs/report/total-student/list.html",
            controller: "virtualFairsTotalStudentController",
            controllerAs: "virtualFairTotalStudent",
          },
        },
        resolve: {
          virtualfairs: function () {
            return null;
          },
          isPlatformRental: () => false,
        }
      })
      .state("root.virtualfair.universityConnect", {
        url: "/university-connect",
        views: {
          "inner-view@root": {
            templateUrl: "templates/virtualfairs/university-connect/list.html",
            controller: "UniversityConnectController",
            controllerAs: "universityConnect",
          },
        },
      })
      .state("root.virtualfair.universityConnect.schedules", {
        url: "/university-connect/schedules",
        data: { generateSchedules: false },
        views: {
          "inner-view@root": {
            templateUrl:
              "templates/virtualfairs/university-connect/schedule/list.html",
            controller: "UniversityConnectScheduleController",
            controllerAs: "universityConnectSchedule",
          },
        },
      })
      .state("root.virtualfair.universityConnect.generateSchedules", {
        url: "/university-connect/{id}/generate-schedules",
        data: { generateSchedules: true },
        views: {
          "inner-view@root": {
            templateUrl:
              "templates/virtualfairs/university-connect/schedule/list.html",
            controller: "UniversityConnectScheduleController",
            controllerAs: "universityConnectSchedule",
          },
        },
      })
      .state("root.virtualfair.reports", {
        url: "/reports",
        views: {
          "inner-view@root": {
            templateUrl: "templates/virtualfairs/report/reports.html",
            controller: "virtualFairsReportController",
            controllerAs: "virtualFairsReport",
          },
        },
      })
      .state("root.virtualfair.reports.platformTests", {
        url: "/reports/platform-tests",
        views: {
          "inner-view@root": {
            templateUrl:
              "templates/virtualfairs/report/exhibitor/platform-tests/list.html",
            controller: "VirtualFairsPlatformTestsController",
            controllerAs: "virtualFairsPlatformTests",
          },
        },
      })
      .state("root.virtualfair.reports.exhibitorByExpo", {
        url: "/reports/exhibitor-by-expo",
        views: {
          "inner-view@root": {
            templateUrl: "templates/virtualfairs/report/exhibitor/exhibitors-by-expo/reportFilter.html",
            controller: "VirtualFairExhibitorsByExpoController",
            controllerAs: "virtualFairExhibitorsByExpo",
          },
        },
      })
      .state ('root.virtualfair.reports.virtualFairSurvey', {
        url: '/reports/survey',
        views: {
            'inner-view@root': {
                templateUrl: 'templates/virtualfairs/report/exhibitor/roadshow-survey/reportFilter.html',
                controller: 'VirtualFairSurveyController',
                controllerAs: 'virtualFairSurvey'
            }
        }
      })
      .state("root.virtualfair.reports.exhibitor", {
        abstract: true,
        url: "/exhibitor",
        resolve: {
          /* Inserir as regras de Acl aqui! */
        },
      })
      .state("root.virtualfair.reports.exhibitor.representatives", {
        url: "/representatives",
        views: {
          "inner-view@root": {
            templateUrl:
              "templates/virtualfairs/report/exhibitor/representatives/list.html",
            controller: "VirtualFairExhibitorRepresentativeController",
            controllerAs: "virtualFairExhibitorRepresentative",
          },
        },
        resolve: {
          virtualFairs: function () {
            return null;
          },
          isPlatformRental: () => false,
        }
      })
      .state("root.virtualfair.reports.students", {
        abstract: true,
        url: "/students",
        resolve: {
          /* Inserir as regras de Acl aqui! */
        },
      })
      .state("root.virtualfair.reports.boothTableBooked", {
        url: "/boothtablebooked",
        views: {
          "inner-view@root": {
            templateUrl:
              "templates/virtualfairs/report/boothtablebooked/reportFilter.html",
            controller: "VirtualFairBoothTableBookedController",
            controllerAs: "virtualFairBoothTableBookedController",
          },
        },
      })
      .state("root.virtualfair.reports.students.enrolled", {
        url: "/enrolled",
        views: {
          "inner-view@root": {
            templateUrl:
              "templates/virtualfairs/report/students-enrolled/reportFilter.html",
            controller: "VirtualFairStudentsEnrolledController",
            controllerAs: "virtualFairStudentsEnrolled",
          },
        },
      })
      .state("root.virtualfair.reports.students.interestAreas", {
        url: "/interest-areas",
        views: {
          "inner-view@root": {
            templateUrl:
              "templates/virtualfairs/report/students-interest-areas/reportFilter.html",
            controller: "VirtualFairStudentsInterestAreasController",
            controllerAs: "virtualFairStudentsInterestAreas",
          },
        },
      })
      .state("root.virtualfair.reports.students.phones", {
        url: "/phones",
        views: {
          "inner-view@root": {
            templateUrl:
              "templates/virtualfairs/report/students/phones/reportFilter.html",
            controller: "VirtualFairStudentsPhonesController",
            controllerAs: "virtualFairStudentsPhones",
          },
        },
      })
      .state("root.virtualfair.reports.counselors", {
        url: "/counselors",
        views: {
          "inner-view@root": {
            templateUrl:
              "templates/virtualfairs/report/counselors/reportFilter.html",
            controller: "VirtualFairCounselorsController",
            controllerAs: "vfCounselorsCtrl",
          },
        },
      })
      .state("root.virtualfair.reports.platformIntegration", {
        url: "/platform-integration",
        views: {
          "inner-view@root": {
            templateUrl:
              "templates/virtualfairs/report/platform-integration/reportFilter.html",
            controller: "VirtualFairPlatformIntegrationController",
            controllerAs: "virtualFairPlatformIntegration",
          },
        },
      })
      .state("root.virtualfair.reports.platformSync", {
        url: "/platform-sync",
        views: {
          "inner-view@root": {
            templateUrl:
              "templates/virtualfairs/report/platform-sync/reportFilter.html",
            controller: "VirtualFairPlatformSyncController",
            controllerAs: "virtualFairPlatformSync",
          },
        },
      })
      .state("root.virtualfair.reports.eventSupport", {
        url: "/event-support",
        views: {
          "inner-view@root": {
            templateUrl:
              "templates/virtualfairs/report/event-support/reportFilter.html",
            controller: "VirtualFairEventSupportController",
            controllerAs: "virtualFairEventSupport",
          },
        },
      })


      .state("root.virtualfair.hosts", {
        url: "/hosts",
        views: {
          "inner-view@root": {
            templateUrl:
              "templates/virtualfairs/hosts/reportFilter.html",
            controller: "VirtualFairHostsController",
            controllerAs: "virtualFairHosts",
          },
        },
      })
      .state("root.virtualfair.hosts.form", {
        url: "/form/:id?",
        resolve: {
          virtualfair: function (VirtualFairService, $stateParams) {
            if($stateParams.id) {
              return VirtualFairService.getVirtualFairBySettings($stateParams.id).then(function(response) {
                return response.data;
              });
            }
            return null;
          }
        },
        views: {
          "inner-view@root": {
            templateUrl: "templates/virtualfairs/hosts/form/form.html",
            controller: "VirtualFairHostsFormController",
            controllerAs: "virtualFairHostsForm",
          },
        },
        params: {id: null},
      })

      .state("root.virtualfair.settings", {
        url: "/settings",
        views: {
          "inner-view@root": {
            templateUrl:
              "templates/virtualfairs/settings/reportFilter.html",
            controller: "VirtualFairSettingsController",
            controllerAs: "virtualFairSettings",
          },
        },
      })
      .state("root.virtualfair.settings.form", {
        url: "/form/:id?",
        resolve: {
          virtualfair: function (VirtualFairService, $stateParams) {
            if($stateParams.id) {
              return VirtualFairService.getVirtualFairBySettings($stateParams.id).then(function(response) {
                return response.data;
              });
            }
            return null;
          }
        },
        views: {
          "inner-view@root": {
            templateUrl: "templates/virtualfairs/settings/form/form.html",
            controller: "VirtualFairSettingsFormController",
            controllerAs: "virtualFairSettingsForm",
          },
        },
        params: {id: null},
      })
      .state("root.virtualfair.pavilions", {
        url: "/pavilions",
        resolve: {
          fairExposByPavilion: function(){
            return []
          },
          fairExposByPavilionAdded: function(){
            return []
          }
        },
        views: {
          "inner-view@root": {
            templateUrl:
              "templates/virtualfairs/pavilions/reportFilter.html",
            controller: "VirtualFairPavilionsController",
            controllerAs: "virtualFairPavilions",
          },
        },
      })
      .state("root.virtualfair.pavilions.expos", {
        url: "/:id/expos",
        resolve: {
          fairExposByPavilion: function(VirtualFairService, $stateParams) {
            if($stateParams.id) {
              return VirtualFairService.getVirtualFairExposByPavilion($stateParams.id).then(function(response) {
                return response.data;
              });
            }
            return [];
          },
          fairExposByPavilionAdded: async function(VirtualFairService, $stateParams) {
            if($stateParams.id) {
              const result = await VirtualFairService.getVirtualFairExposByPavilionAdded($stateParams.id)
              return result.data
            }
            return [];
          }
        },
        views: {
          "inner-view@root": {
            templateUrl: "templates/virtualfairs/pavilions/expos/list/list.html",
            controller: "VirtualFairPavilionsController",
            controllerAs: "virtualFairPavilions",
          },
        },
        params: {id: null},
      })
      .state("root.virtualfair.reports.postEvent", {
        abstract: true,
        url: "/post-event",
        resolve: {
          /* Inserir as regras de Acl aqui! */
        },
      })
      .state("root.virtualfair.reports.postEvent.generalInformation", {
        url: "/general-information",
        views: {
          "inner-view@root": {
            templateUrl:
              "templates/virtualfairs/report/post-event/general-information/reportFilter.html",
            controller: "VirtualFairGeneralInformationController",
            controllerAs: "virtualFairGeneralInformation",
          },
        },
        resolve: {
          virtualFairs: function () {
            return null;
          },
          isPlatformRental: () => false,
        }
      })
      .state("root.virtualfair.reports.postEvent.cyberSessionInformation", {
        url: "/cybersessions-information",
        views: {
          "inner-view@root": {
            templateUrl:
              "templates/virtualfairs/report/post-event/cybersessions-info/reportFilter.html",
            controller: "VirtualFairCyberSessionsInfoController",
            controllerAs: "virtualFairCyberSessionsInformation",
          },
        },
        resolve: {
          virtualFairs: function (VirtualFairService) {
            return VirtualFairService.getCyberSessions()
              .then(response => response.data)
          },
          isPlatformRental: () => false,
        }
      })
      .state("root.virtualfair.reports.postEvent.leadsBooth", {
        url: "/leads-per-booth",
        views: {
          "inner-view@root": {
            templateUrl:
              "templates/virtualfairs/report/post-event/leads-booth/reportFilter.html",
            controller: "VirtualFairLeadsBoothController",
            controllerAs: "virtualFairLeadsBooth",
          },
        },
        resolve: {
          virtualFairs: function () {
            return null;
          },
          isPlatformRental: () => false,
        }
      })
      .state("root.virtualfair.reports.postEvent.ratingComments", {
        url: "/rating-comments",
        resolve: {
          cyberSessions: function(VirtualFairService) {
            return VirtualFairService.getCyberSessions()
              .then(response => response.data)
          },
        },
        views: {
          "inner-view@root": {
            templateUrl: "templates/virtualfairs/rating-comments/reportFilter.html",
            controller: "VirtualFairRatingCommentsController",
            controllerAs: "virtualFairRatingComments",
          }
        }
      })
      .state("root.virtualfair.reports.postEvent.prizes", {
        url: "/prizes",
        resolve: {
          expos: function(VirtualFairService) {
            return VirtualFairService.getAll()
                .then(response => response.data)
          },
        },
        views: {
          "inner-view@root": {
            templateUrl: "templates/virtualfairs/prizes/reportFilter.html",
            controller: "VirtualFairPrizesController",
            controllerAs: "vfPrizes",
          }
        }
      })
      .state("root.virtualfair.preRegistrations", {
        abstract: true,
        url: "/registration",
        resolve: {
          /* Inserir as regras de Acl aqui! */
        },
      })

      .state("root.virtualfair.preRegistrations.register", {
        url: "/:userId/register/:prId",
        views: {
          "inner-view@root": {
            templateUrl:
              "templates/virtualfairs/pre-approved/registration/registration-form.html",
            controller: "VirtualFairRegistrationController",
            controllerAs: "vfRegCtrl",
          },
        },
        resolve: {
          expos: function ($state, $stateParams, toastr, VirtualFairService) {
            return VirtualFairService.getAllActive({
              active: true,
              show_to_costumer: true,
              include_past_date: false,
              user_id: $stateParams.userId,
              pr_id: $stateParams.prId,
            })
            .then((response) => {
                return response.data;
            })
            .catch((err) => {
                toastr.error("Something went wrong. Please try again later");
                console.log(err);
                return $state.go("root.physicalfairs.preRegistrations", null, {
                  reload: true,
                });
              });
          },
        },
      })

      .state("root.virtualfair.reports.platformRental", {
        url: "/platform-rentals",

        views: {
          "inner-view@root": {
            templateUrl:
              "templates/virtualfairs/platform-rental/list/list.html",
            controller: "ManagePlatformRentalListController",
            controllerAs: "managePlatformRentalList",

          },
        },

      })
      .state("root.virtualfair.reports.platformRental.scheduleReport", {
        url: "/schedule-report",
        views: {
          "inner-view@root": {
            templateUrl: "templates/virtualfairs/platform-rental/schedule-report/reportFilter.html",
            controller: "PlatformRentalScheduleReportController",
            controllerAs: "platformRentalScheduleReport",
          },
        },
      })
      .state("root.virtualfair.reports.platformRental.create", {
        url: "/create",
        resolve: {
          virtualFairs: function(VirtualFairService) {
            return VirtualFairService.getAll()
              .then(response => response.data)
          },
          id: function() {
            return null
          },
        },
        views: {
          "inner-view@root": {
            templateUrl:
              "templates/virtualfairs/platform-rental/form/form.html",
            controller: "ManagePlatformRentalFormController",
            controllerAs: "managePlatformRentalForm",
          },
        },
      })
      .state("root.virtualfair.reports.platformRental.edit", {
        url: "/:id/edit",
        resolve: {
          virtualFairs: function(VirtualFairService) {
            return VirtualFairService.getAll()
              .then(response => response.data)
          },
          id: function($stateParams) {
            return $stateParams.id;
          },
        },
        views: {
          "inner-view@root": {
            templateUrl:
              "templates/virtualfairs/platform-rental/form/form.html",
            controller: "ManagePlatformRentalFormController",
            controllerAs: "managePlatformRentalForm",
          },
        },
      })

      .state("root.virtualfair.reports.microsites", {
        url: "/microsites",

        views: {
          "inner-view@root": {
            templateUrl:
              "templates/virtualfairs/microsites/list/list.html",
            controller: "VirtualFairMicrositesListController",
            controllerAs: "virtualFairMicrositesList",

          },
        },
        resolve: {
          virtualFairs: function(VirtualFairService) {
            return VirtualFairService.getAll()
              .then(response => response.data)
          },
        },

      })
      .state("root.virtualfair.reports.microsites.create", {
        url: "/create",
        resolve: {
          virtualFairs: function(VirtualFairService) {
            return VirtualFairService.getAll()
              .then(response => response.data)
          },
          id: function() {
            return null
          },
        },
        views: {
          "inner-view@root": {
            templateUrl:
              "templates/virtualfairs/microsites/form/form.html",
            controller: "VirtualFairMicrositesFormController",
            controllerAs: "virtualFairMicrositesForm",
          },
        },
      })
      .state("root.virtualfair.reports.microsites.edit", {
        url: "/:id/edit",
        resolve: {
          virtualFairs: function(VirtualFairService) {
            return VirtualFairService.getAll()
              .then(response => response.data)
          },
          id: function($stateParams) {
            return $stateParams.id;
          },
        },
        views: {
          "inner-view@root": {
            templateUrl:
              "templates/virtualfairs/microsites/form/form.html",
            controller: "VirtualFairMicrositesFormController",
            controllerAs: "virtualFairMicrositesForm",
          },
        },
      })
      .state("root.virtualfair.reports.postNetworking", {
        url: "/post-networking",
        resolve: {
          virtualFairs: function(VirtualFairService) {
            return VirtualFairService.getPostNetworkingEvents()
              .then(response => response.data)
          },
          isPlatformRental: () => false,
        },
        views: {
          "inner-view@root": {
            templateUrl: "templates/virtualfairs/report/post-networking/reportFilter.html",
            controller: "VirtualFairPostNetworkingController",
            controllerAs: "virtualFairPostNetworking",
          },
        },
      })
      .state("root.virtualfair.reports.generateStats", {
        url: "/generate-stats",
        resolve: {
          virtualFairs: function(VirtualFairService) {
            return VirtualFairService.getAll()
              .then(response => response.data)
          },
        },
        views: {
          "inner-view@root": {
            templateUrl: "templates/virtualfairs/report/generate-stats/reportFilter.html",
            controller: "VirtualFairGenerateStatsController",
            controllerAs: "virtualFairGenerateStats",
          },
        },
      })
      .state("root.virtualfair.reports.importScheduleUrl", {
        url: "/import-schedule",
        resolve: {
          virtualFairs: function(VirtualFairService) {
            return VirtualFairService.getAll()
              .then(response => response.data)
          },
        },
        views: {
          "inner-view@root": {
            templateUrl: "templates/virtualfairs/import-schedule-url/reportFilter.html",
            controller: "VirtualFairImportScheduleUrlController",
            controllerAs: "virtualFairImportScheduleUrl",
          }
        },
      })
      .state("root.virtualfair.reports.eventContacts", {
        url: "/event-contacts",
        resolve: {
          virtualFairs: function(VirtualFairService) {
            return VirtualFairService.getVirtualFairsBySemester()
              .then(response => response.data)
          },
          semesters: function(VirtualFairService) {
            return VirtualFairService.getSemesters()
              .then(response => response.data)
          }
        },
        views: {
          "inner-view@root": {
            templateUrl: "templates/virtualfairs/report/event-contacts/reportFilter.html",
            controller: "VirtualFairEventContactsController",
            controllerAs: "virtualFairEventContacts",
          }
        }
      })
      .state("root.virtualfair.reports.cyberSessions", {
        url: "/cyber-sessions",
        resolve: {
          cyberSessions: function(VirtualFairService) {
            return VirtualFairService.getCyberSessions()
              .then(response => response.data)
          },
        },
        views: {
          "inner-view@root": {
            templateUrl: "templates/virtualfairs/cyber-sessions/reportFilter.html",
            controller: "VirtualFairCyberSessionsController",
            controllerAs: "virtualFairCyberSessions",
          }
        }
      })
      .state("root.virtualfair.reports.cyberSessionsWaitlist", {
        url: "/cyber-sessions/waitlist",
        resolve: {
          cyberSessions: function(VirtualFairService) {
            return VirtualFairService.getCyberSessions()
              .then(response => response.data)
          },
        },
        views: {
          "inner-view@root": {
            templateUrl: "templates/virtualfairs/cyber-sessions-whitelist/reportFilter.html",
            controller: "VirtualFairCyberSessionsWaitlistController",
            controllerAs: "virtualFairCyberSessionsWaitlist",
          }
        }
      })
      .state("root.virtualfair.addEventData", {
        url: "/add-event-data",
        views: {
          "inner-view@root": {
            templateUrl:
              "templates/virtualfairs/add-event-data/virtualFairAddEventData.html",
            controller: "VirtualFairAddEventDataController",
            controllerAs: "virtualFairAddEventData",
          },
        },
      })
      .state("root.virtualfair.helpUs", {
        url: "/help-us-help-you",
        views: {
          "inner-view@root": {
            templateUrl:
                "templates/virtualfairs/help-us-help-you/report.html",
            controller: "virtualFairHelpUsHelpYouController",
            controllerAs: "virtualFairHelpUsHelpYouForm",
          },
        },
      })
      .state("root.virtualfair.reports.eventNumbers", {
        url: "/event-numbers",
        views: {
          "inner-view@root": {
            templateUrl: "templates/virtualfairs/report/event-numbers/reportFilter.html",
            controller: "VirtualFairEventNumbersController",
            controllerAs: "virtualFairEventNumbers",
          }
        }
      })
      .state("root.virtualfair.whatsappReminder", {
        url: "/whatsapp-reminder",
        views: {
          "inner-view@root": {
            templateUrl: "templates/virtualfairs/whatsapp-reminder/reminder.html",
            controller: "VirtualFairWhatsAppReminderController",
            controllerAs: "virtualFairWhatsAppReminder",
          }
        }
      })
      .state("root.virtualfair.summary", {
        url: "/summary",
        views: {
          "inner-view@root": {
            templateUrl:
              "templates/virtualfairs/report/summary/reportFilter.html",
            controller: "VirtualFairSummaryController",
            controllerAs: "virtualFairSummary",
          },
        },
        params: {
          msg: null,
          error: false,
        },
      })
  }

  function networkingEventUsersTypes() {
    return [
      { name: "Exhibitor", id: "exhibitor" },
      { name: "Partner", id: "partner" },
    ];
  }
})();
